// src/pages/UsersList.jsx
import React, { useEffect, useState } from "react";
import { getUsers } from "../api/userApi";
import { Table, Button, Typography, Modal } from "antd";
import CreateUserForm from "./CreateUserForm";

const { Title } = Typography;

// Definición de colores corporativos (consistente con AdminDashboard)
const colors = {
  background: "#0f1117",
  cardBg: "#1a1c23",
  headerBg: "#12141b",
  primary: "#3b82f6",
  secondary: "#6366f1",
  accent: "#22c55e",
  text: "#e3e4e8",
  textMuted: "#9ca3af",
  border: "#2d3748",
};

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const fetchUsers = async () => {
    try {
      const response = await getUsers();
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Rol",
      dataIndex: "role",
      key: "role",
      sorter: (a, b) => a.role.localeCompare(b.role),
      render: (role) => (
        <span
          style={{
            color:
              role === "ADMIN"
                ? colors.primary
                : role === "CLIENT_ADMIN"
                ? colors.secondary
                : colors.accent,
            fontWeight: 500,
          }}
        >
          {role}
        </span>
      ),
    },
  ];

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleSuccess = () => {
    closeModal();
    fetchUsers();
  };

  return (
    <div
      style={{
        background: colors.background,
        color: colors.text,
        padding: "2rem",
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        minHeight: "calc(100vh - 80px)",
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <Title
          level={2}
          style={{
            color: colors.primary,
            margin: 0,
            fontSize: "28px",
            fontWeight: "600",
          }}
        >
          Listado de Usuarios
        </Title>
        <Button
          type="primary"
          onClick={openModal}
          style={{
            background: colors.primary,
            borderColor: colors.primary,
            height: "40px",
            borderRadius: "8px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            transition: "all 0.3s ease",
            "&:hover": {
              background: `${colors.primary}dd`,
              transform: "translateY(-2px)",
            },
          }}
        >
          Crear Usuario
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={users}
        rowKey="id"
        style={{
          background: colors.cardBg,
          borderRadius: "12px",
          overflow: "hidden",
        }}
        pagination={{
          style: {
            margin: "20px 0",
            ".ant-pagination-item-active": {
              backgroundColor: colors.primary,
              borderColor: colors.primary,
            },
            ".ant-pagination-item a": {
              color: colors.text,
            },
          },
        }}
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  background: colors.headerBg,
                  color: colors.text,
                  borderBottom: `1px solid ${colors.border}`,
                  padding: "16px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              />
            ),
          },
        }}
        onRow={(record) => ({
          style: {
            transition: "all 0.3s ease",
            "&:hover": {
              background: colors.headerBg,
            },
          },
        })}
      />

      <Modal
        title={
          <span
            style={{
              color: colors.primary,
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            Crear Nuevo Usuario
          </span>
        }
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
        style={{
          "& .ant-modal-content": {
            background: colors.cardBg,
            borderRadius: "12px",
          },
        }}
        bodyStyle={{
          background: colors.cardBg,
          color: colors.text,
          padding: "24px",
        }}
      >
        <CreateUserForm onSuccess={handleSuccess} onCancel={closeModal} />
      </Modal>
    </div>
  );
};

export default UsersList;
